import { Component } from 'react'

import BrokenComponent from '~/components/BrokenComponent'
import logger from '~/lib/logger'

const withErrorBoundary = ({ renderError } = {}) => {
    return WrappedComponent => {
        return class ErrorBoundary extends Component {
            state = { error: null }

            componentDidCatch(error, errorInfo) {
                this.setState({ error })
                logger.exception(error, { extra: errorInfo })
            }

            render() {
                if (this.state.error) {
                    return renderError || <BrokenComponent />
                }

                return <WrappedComponent {...this.props} />
            }
        }
    }
}

export default withErrorBoundary
